import Button from '@mui/material/Button'
import KNDialog from 'components/KNDialog/KNDialog'
import KNFormText from 'components/KNForm/KNFormText'
import { type MapSelection } from 'components/KNMapLibre/types'
import { type ReactElement, useEffect } from 'react'
import { type SubmitHandler, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { mapSelectionToArea } from './CarrierProfile.helpers'
import { type Area } from './CarrierProfile.types'

interface AreaNameDialogPayload {
  selection: MapSelection
}

export interface AreaNameDialogProps {
  payload: AreaNameDialogPayload
  open: boolean
  onClose: () => void
  onAction: (area: Area) => void
}

export type AreaNameFormValues = {
  name: string
}

const AreaNameDialog = ({
  payload,
  open,
  onAction,
  onClose,
}: AreaNameDialogProps): ReactElement => {
  const { t } = useTranslation()
  const { handleSubmit, reset, control, formState } = useForm<AreaNameFormValues>()

  useEffect(() => {
    if (open) {
      reset()
    }
  }, [open])

  const onSubmit: SubmitHandler<AreaNameFormValues> = (data: AreaNameFormValues): void => {
    const area = mapSelectionToArea(payload.selection, data.name)
    if (area) {
      onAction(area)
    }
  }

  return (
    <KNDialog
      open={open}
      onClose={onClose}
      closeLabel={t('general.cancel')}
      preventClosing={formState.isSubmitting}
      maxWidth="xs"
      actions={
        <Button
          type="submit"
          color="secondary"
          variant="contained"
          loading={formState.isSubmitting}
          onClick={handleSubmit(onSubmit)}
        >
          {t('general.save')}
        </Button>
      }
      onSubmit={handleSubmit(onSubmit)}
    >
      <KNFormText
        name="name"
        label={t('screens.cs.carrier_profile.lanes_and_regions.form.area_name')}
        control={control}
        autoFocus
      />
    </KNDialog>
  )
}

export default AreaNameDialog
